import { LocalstorageTokensKeys } from '@/shared/models/tokens-keys.interface';
import { DOCUMENT } from '@angular/common';
import { inject, Injectable } from '@angular/core';
import { LOCALSTORAGE_TOKENS } from '../constants/injection-tokens';

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  private darkMode = false;
  private readonly doc = inject<Document>(DOCUMENT);

  private readonly localstorageTokensKeys: LocalstorageTokensKeys =
    inject<LocalstorageTokensKeys>(LOCALSTORAGE_TOKENS);

  toggleTheme() {
    this.darkMode = !this.darkMode;
    this.setTheme(this.darkMode);
  }

  get isDarkMode(): boolean {
    return this.darkMode;
  }

  setDarkMode(isDark: boolean) {
    this.setTheme(isDark);
  }

  private setTheme(isDark: boolean) {
    this.darkMode = isDark;
    const htmlEl = this.doc.documentElement;

    if (isDark) {
      htmlEl.classList.add('dark');
      localStorage.setItem(
        this.localstorageTokensKeys.theme,
        JSON.stringify('dark'),
      );
    } else {
      htmlEl.classList.remove('dark');
      localStorage.setItem(
        this.localstorageTokensKeys.theme,
        JSON.stringify('light'),
      );
    }
  }

  initTheme(): void {
    const rawTheme = localStorage.getItem(this.localstorageTokensKeys.theme);
    const savedTheme = rawTheme ? (JSON.parse(rawTheme) as string) : null;
    if (savedTheme) {
      this.darkMode = savedTheme === 'dark';
      this.setTheme(this.darkMode);
    } else {
      // Default to light mode if no theme is saved
      this.setTheme(false);
    }
  }
}
